module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "gbold"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many thanks to all the wonderful folks at Morgan James for publishing this book and for guiding me through the process in such a kind, encouraging, and professional manner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am so grateful to Tom Dean for catching the vision for this book and for being a mentor and friend throughout the process.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks also to my friend Mary Jo Tate for her extraordinary editing skills. She makes me a better writer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my husband, Mont, and to my ten children (You read that right!), I could never do what I do without your support. I love each of you more than words could ever say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And to Jesus: “To you alone; to you alone and not to me must glory be given because of your constant love and faithfulness” (Psalm 115:1).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 75
// module chunks = 0